export default __webpack_public_path__ + "static/phone-84db4a9787536cd35962d533f144a1f1.svg";